import React, { ReactNode, useMemo } from 'react';
import { RouteMetricCards } from './RouteMetricCards';
import { ROUTE_CELL_ICON_PATHS, IRouteIconCell } from './RouteMetricCardsComponents/RouteIconCell';

export interface Props {
  id: string;
  RouteName: string;
  routeColor?: string;
  routeDescription: string;
  routeToolTipText?: string;
  correlation: string;
  pricePerTon: string;
  isPicked: boolean;
  onClickOnRoute: () => void;
  calenderCellValue: string;
  quantityCellValue: string;
  collateralCellValue: string;
  riskCellValue: string;
  carbonFootPrintCell?: string;
  massUnit?: string;
  isPhysicalDeliveryCell?: boolean;
  isShipmentProtectedCell?: boolean;
  isFlexibleCell?: boolean;
  isFullGuarantee?: boolean;
  children?: ReactNode;
  isMinimalCell?: boolean;
  showMoreInfo?: () => void;
  hidePriceCorrelation?: boolean;
}

export const BalanceRouteMetricCard: React.FC<Props> = ({
  RouteName,
  correlation,
  id,
  isPicked,
  onClickOnRoute,
  pricePerTon,
  routeDescription,
  routeColor = '',
  routeToolTipText,
  calenderCellValue,
  collateralCellValue,
  quantityCellValue,
  riskCellValue,
  isFlexibleCell,
  isFullGuarantee,
  isPhysicalDeliveryCell,
  isShipmentProtectedCell,
  carbonFootPrintCell,
  massUnit = 'ton',
  children,
  isMinimalCell = false,
  showMoreInfo,
  hidePriceCorrelation = false,
}) => {
  const iconCellList = useMemo(() => {
    const cells: IRouteIconCell[] = isMinimalCell
      ? [
          {
            iconPath: ROUTE_CELL_ICON_PATHS['date-range'],
            toolTipText: '',
            iconText: calenderCellValue,
          },
          {
            iconPath: ROUTE_CELL_ICON_PATHS.quantity,
            toolTipText: '',
            iconText: quantityCellValue,
          },
        ]
      : [
          {
            iconPath: ROUTE_CELL_ICON_PATHS['date-range'],
            toolTipText: '',
            iconText: calenderCellValue,
          },
          {
            iconPath: ROUTE_CELL_ICON_PATHS.quantity,
            toolTipText: '',
            iconText: quantityCellValue,
          },
          {
            iconPath: ROUTE_CELL_ICON_PATHS.collateral,
            toolTipText: '',
            iconText: collateralCellValue,
          },
          {
            iconPath: ROUTE_CELL_ICON_PATHS.risk,
            toolTipText: '',
            iconText: riskCellValue,
          },
          ...(isPhysicalDeliveryCell
            ? [
                {
                  iconPath: ROUTE_CELL_ICON_PATHS.physical_delivery,
                  toolTipText: '',
                },
              ]
            : []),
          ...(isShipmentProtectedCell
            ? [
                {
                  iconPath: ROUTE_CELL_ICON_PATHS.shipment,
                  toolTipText: '',
                },
              ]
            : []),
          ...(isFlexibleCell
            ? [
                {
                  iconPath: ROUTE_CELL_ICON_PATHS.flexibility,
                  toolTipText: '',
                },
              ]
            : []),
          ...(isFullGuarantee
            ? [
                {
                  iconPath: ROUTE_CELL_ICON_PATHS.fullGuarantee,
                  toolTipText: '',
                },
              ]
            : []),
          // {
          //   iconPath: ROUTE_CELL_ICON_PATHS.carbon_footprint,
          //   toolTipText: '',
          //   iconText: carbonFootPrintCell,
          // },
        ];

    return cells;
  }, [
    calenderCellValue,
    quantityCellValue,
    collateralCellValue,
    riskCellValue,
    carbonFootPrintCell,
    isPhysicalDeliveryCell,
    isShipmentProtectedCell,
    isFlexibleCell,
    isFullGuarantee,
    isMinimalCell,
  ]);

  const priceAndCorrelation: { title: string; valueAsString: string }[] = hidePriceCorrelation
    ? []
    : [
        { title: 'Correlation', valueAsString: correlation },
        { title: 'Price/' + massUnit, valueAsString: pricePerTon },
      ];

  return (
    <RouteMetricCards
      id={id}
      title={RouteName}
      subTitle={routeDescription}
      routeColor={routeColor}
      isPicked={isPicked}
      onClickOnRoute={onClickOnRoute}
      iconCellList={iconCellList}
      titleWithValue={priceAndCorrelation}
      toolTipText={routeToolTipText}
      showMoreInfo={showMoreInfo}
    >
      {children}
    </RouteMetricCards>
  );
};
